
// src/components/InfoCard.tsx
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface InfoCardProps {
    title: string;
    icon: LucideIcon;
    iconColor: string;
    iconBgColor: string;
    children: React.ReactNode;
}

export default function InfoCard({
                                     title,
                                     icon: Icon,
                                     iconColor,
                                     iconBgColor,
                                     children
                                 }: InfoCardProps) {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center mb-4">
                <div className={`w-8 h-8 ${iconBgColor} rounded-full flex items-center justify-center mr-3`}>
                    <Icon className={`w-5 h-5 ${iconColor}`} />
                </div>
                <h3 className="font-semibold text-gray-900">{title}</h3>
            </div>
            {children}
        </div>
    );
}